import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import CreateContactModal from '../teams/CreateContactModal';
import Select from 'react-select';
import GreenLeafApi from '../utils/GreenLeafApi';
import {withRouter} from 'react-router';

class ContactSelector extends Component {

  constructor(props) {
    super(props);

    let contact = props.contact || null;
    if (contact) contact.name = contact.first_name + ' ' + contact.last_name;

    this.state = {
      contact,
      showModal: false,
      error: null,
    };
  }

  saveContact = async (contact) => {
    contact.company_id = this.props.match.params.companyId;

    try {
      let con = (await GreenLeafApi.Contact.create(contact)).data;

      con.name = con.first_name + ' ' + con.last_name;
      this.setState({
        contact: con,
        showModal: false,
      });
      this.props.onSelect(con);
    } catch(e) {
      this.setState({error: e.errors});
    }
  };

  handleContactChange = (contact) => {
    if (contact && !contact.id) {
      this.setState({ showModal: true });
      return;
    }

    this.setState({contact});
    this.props.onSelect(contact);
  };

  getContacts = async (input, callback) => {
    if (!input && input.length < 3) {
      return callback(null, { options: [] });
    }

    input = input.split(' ');

    try {
      const options = await GreenLeafApi.Contact.get(
        {
          companyId: this.props.match.params.companyId,
          firstName: `%25${input[0]}%25`,
          lastName: `%25${input[1] ? input[1] : ''}%25`
        });

      options.data.forEach(o => o.name = o.first_name + ' ' + o.last_name);

      callback(null, { options: options.data });
    } catch (e) {
      this.setState({error: e.errors});
    }
  };

  render() {
    return (
      <Fragment>
        <Select.AsyncCreatable
          style={{ width: '250px' }}
          multi={false}
          value={this.state.contact}
          onChange={this.handleContactChange}
          loadOptions={this.getContacts}
          labelKey="name"
          valueKey="name"
        />

        { this.state.showModal &&
        <CreateContactModal
          show={this.state.showModal}
          handleClose={() => this.setState({ showModal: false })}
          onSave={this.saveContact}/>
        }
      </Fragment>
    );
  }
}

ContactSelector.propTypes = {
  onSelect: PropTypes.func,
  contact: PropTypes.object,
};

export default withRouter(ContactSelector);



// WEBPACK FOOTER //
// ./src/components/engagement/ContactSelector.js